<template>
  <div v-if="productId ==='YL-YPD'" class='onlyYiLianInfo'>
    <p class="tip">温馨提示该产品：</p>
    <p><span class="highlight">3-12 </span>期（含），担保费率<span class="highlight"> 3%;</span></p>
    <p><span class="highlight">13-24 </span>期（含），担保费率<span class="highlight"> 4%;</span></p>
    <p><span class="highlight">25-36 </span>期（含），担保费率<span class="highlight"> 5%;</span></p>
  </div>
</template>
<script>
export default {
name: 'onlyYiLianInfo',
props: {
  productId: {
    type: String,
    default: '',
  },
},
data() {
  return {
  };
},
mounted() {
},
// YL-YPD
};
</script>
<style lang="scss" scoped>
.onlyYiLianInfo{
margin: 30px 15px;
padding: 15px;
border-radius: 4px;
box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.03), 0 1px 6px -1px rgba(0, 0, 0, 0.03), 0 2px 4px 0 rgba(0, 0, 0, 0.03);
p {
  padding: 0;
  margin: 0;
  text-align: left;
  font-size: 14px;
  color: #1c2438;
}
.tip{
  font-size: 16px;
  font-weight: 600;
  border-bottom: 1px solid #eee;
  margin-bottom: 15px;
  position: relative;
  &::after{
    content: '';
    display: block;
    width: 100px;
    height: 6px;
    border-radius: 4px 0 4px 0;
    background: linear-gradient(to right, #ff6538, #fff);
  }
}
.highlight{
  font-weight: 600;
}
}
</style>
